import { AppContext } from "@/App";
import OverviewComponent, { ProjectOverviewRow } from "../Components/OverviewComponent";
import ProjectHealth from "../Components/ProjectHealth";
import { RadialChartComponent } from "../Components/RadialChartComponent";
import WorkstreamHealthReport from "../Components/WorkstreamHealth";
import WorkstreamProgressChart, { WorkstreamProgress } from "../Components/WorkstreamProgressChart";
import { useContext, useEffect } from "react";
import NoProjects from "./NoProjects";
import Loading from "@/Components/loading";
import { WorkstreamHealth } from "@/Components/StatusReport/StatusReportChart";
import React from "react";
import { RaidNotification } from "@/Components/Notifications";
import { useResponsiveZoom } from "@/hooks/use-responsive-zoom";


export type WorkstreamOverview = {
    actual: number;
    planned: number;
    workstreamHealth: WorkstreamHealth; // name is part of the workstream health
}

export type DashboardData = {
    workstreams: WorkstreamOverview[];
    projectHealth: WorkstreamHealth;
    projectOverview: ProjectOverviewRow[]
    currentWeek: number;
    totalWeeks: number;
    notifications: RaidNotification[];
}

function ProjectOverview() {
    const app = useContext(AppContext);
    const zoomLevel = useResponsiveZoom();

    const [isLoading, setIsLoading] = React.useState(true);

    const [workstreamHealth, setWorkstreamHealth] = React.useState<WorkstreamHealth[]>([]);
    const [projectHealth, setProjectHealth] = React.useState<WorkstreamHealth>();
    const [projectProgressActual, setProjectProgressActual] = React.useState(0);
    const [projectProgressPlanned, setProjectProgressPlanned] = React.useState(0);
    const [workstreamProgress, setWorkstreamProgress] = React.useState<WorkstreamProgress[]>([]);
    const [projectOverview, setProjectOverview] = React.useState<ProjectOverviewRow[]>([]);
    const [currentWeek, setCurrentWeek] = React.useState(0);
    const [totalWeeks, setTotalWeeks] = React.useState(0);
    const [notifications, setNotifications] = React.useState<RaidNotification[]>([]);

    useEffect(() => {
        if (app.applicationUser && app.applicationUser.projectUserRoles.length == 0) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        fetch("Reports/Dashboard/" + app.selectedProject?.id)
            .then((response) => response.json())
            .then(data => {
                processDashboardData(data);
                setIsLoading(false);
            })
            .catch((error) => console.error("Error fetching data:", error));

        // Clear previous data when selectedProject changes
        setWorkstreamProgress([]);
        setProjectProgressActual(0);
        setProjectProgressPlanned(0);
        setProjectHealth(undefined);
        setWorkstreamHealth([]);
        setProjectOverview([]);
        setCurrentWeek(0);
        setTotalWeeks(0);
        console.log("project type id: ", app.selectedProject?.projectTypeId);
    }, [app.selectedProject]);

    function processDashboardData(data: DashboardData) {
        setWorkstreamProgress(data.workstreams.map(ws => {
            return {
                name: ws.workstreamHealth.workstreamName ?? "",
                workstreamId: ws.workstreamHealth.workstreamId ?? 0,
                actual: ws.actual,
                planned: ws.planned,
                scheduleStatus: ws.workstreamHealth.schedule
            }
        }));

        const projectPlanned = data.workstreams.reduce((acc, ws) => acc + ws.planned, 0);
        const projectActual = data.workstreams.reduce((acc, ws) => acc + ws.actual, 0);


        setProjectProgressActual(Math.round(projectActual / data.workstreams.length));
        setProjectProgressPlanned(Math.round(projectPlanned / data.workstreams.length));

        setProjectHealth(data.projectHealth);

        setWorkstreamHealth(data.workstreams.map(ws => ws.workstreamHealth));
        setProjectOverview(data.projectOverview);

        setCurrentWeek(data.currentWeek);
        setTotalWeeks(data.totalWeeks);
        setNotifications(data.notifications || []);
    }

    if (isLoading) {
        return <Loading />
    }
    if (app.applicationUser && app.applicationUser.projectUserRoles.length == 0) {
        return <NoProjects />
    }
    return (
        <div className="flex flex-col py-4" style={{ zoom: zoomLevel }}>
            <div className="flex flex-row justify-normal gap-4 px-4 py-2">
                <RadialChartComponent actualPercentage={projectProgressActual} plannedPercentage={projectProgressPlanned} />
                {projectOverview && <OverviewComponent projectOverviewRows={projectOverview} />}
                {projectHealth && <ProjectHealth projectHealth={projectHealth} currentWeek={currentWeek} totalWeeks={totalWeeks} notifications={notifications} setNotifications={setNotifications}/>}
            </div>
            {app.selectedProject?.projectTypeId === 2 && (
            <div className="flex flex-row justify-normal gap-4 px-4 py-2">
                <WorkstreamProgressChart workstreamProgress={workstreamProgress} isMultiProject={false} />
                <WorkstreamHealthReport workstreamHealth={workstreamHealth} />
            </div>
            )}
        </div>
    );
}

export default ProjectOverview;